module.exports = __webpack_public_path__ + "static/media/4.Planner.987ff11e.jpg";